import * as yup from "yup";

const INVALID_EMAIL_FORMAT = "Invalid email format";

export const registerFormSchema = yup.object({
    email: yup
        .string()
        .email(INVALID_EMAIL_FORMAT)
        .required("Email is required"),
});

export const requesterInformationSchema = yup.object({
    requesterFirstName: yup
        .string()
        .min(2, "Your First Name must be at least 2 characters long")
        .max(100, "Your First Name must be at most 100 characters long")
        .required("Your First Name is required"),
    requesterLastName: yup
        .string()
        .min(2, "Your Last Name must be at least 2 characters long")
        .max(100, "Your Last Name must be at most 100 characters long")
        .required("Your Last Name is required"),
    requesterEmail: yup
        .string()
        .email(INVALID_EMAIL_FORMAT)
        .required("Your email is required"),
    requesterDSA: yup
        .boolean()
        .oneOf(
            [true],
            "You shall only submit this request if you have the right and authority to represent the company requesting the data",
        ),
    requesterIdentityDocumentAttachment: yup
        .string()
        .required("File is required"),
});

export const thirdPartyDataRecipientInformationSchema = yup.object({
    thirdPartyDataRecipientName: yup
        .string()
        .min(2, "Requesting company name must be at least 2 characters long")
        .max(100, "Requesting company name must be at most 100 characters long")
        .required("Requesting company name is required"),
    thirdPartyDataRecipientCountryOfRegistration: yup
        .string()
        .required("Selection is required"),
    thirdPartyDataRecipientCertificateOfRegistrationAttachment: yup
        .string()
        .required(
            "Requesting company certificate of registration attachment is required",
        ),
    thirdPartyDataRecipientSMEConfirmation: yup
        .boolean()
        .when("thirdPartyDataRecipientSME", {
            is: true,
            then: (schema) =>
                schema.oneOf(
                    [true],
                    "Confirm that the requesting company qualifies as a small and medium-sized enterprise or a not-for-profit research organization",
                ),
            otherwise: (schema) => schema,
        }),
    thirdPartyDataRecipientGatekeeper: yup
        .boolean()
        .oneOf(
            [true],
            "Gatekeepers are not eligible to receive data under Data Act and shall not submit requests using the Volvo Group Data Act Request Tool.",
        ),
});

export const userInformationSchema = yup.object({
    userInformationName: yup
        .string()
        .min(2, "Name must be at least 2 characters long")
        .max(100, "Name must be at most 100 characters long")
        .required("Name is required"),
    userInformationFleetName: yup
        .string()
        .min(2, "Fleet Name must be at least 2 characters long")
        .max(100, "Fleet Name must be at most 100 characters long")
        .required("Fleet Name is required"),
    userInformationFleetCountryOfRegistration: yup
        .string()
        .required(
            "Select the country where the fleet is registered in customer portal",
        ),
    userInformationFleetAdminEmail: yup
        .string()
        .email(INVALID_EMAIL_FORMAT)
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            INVALID_EMAIL_FORMAT,
        )
        .required("Fleet Admin Email is required")
        .notOneOf(
            [yup.ref("requesterEmail")],
            "Fleet Admin Email must be different from Requester Email",
        ),
});

export const dataSharingAgreementSchema = yup.object({
    dataSharingAgreementDSA: yup
        .boolean()
        .oneOf([true], "DSA must be accepted"),
    dataSharingAgreementVG: yup
        .boolean()
        .oneOf(
            [true],
            "Costs for making data available to the requesting company must be accepted",
        ),
    dataSharingAgreementGDPR: yup
        .boolean()
        .oneOf(
            [true],
            "The requesting company must have a valid legal basis for any processing of personal data contained in the data it will access",
        ),
});

export const connectedProductInformationSchema = yup.object({
    productType: yup.string().required("Product Type is required"),
    productVIN: yup.string().when(["productType"], ([productType], schema) =>
        productType === "VIN"
            ? schema
                  .trim()
                  .transform((v) =>
                      typeof v === "string" ? v.toUpperCase() : v,
                  )
                  .min(17, "Product VIN must be at least 17 characters long")
                  .max(17, "Product VIN must be 17 characters long")
                  .matches(
                      /^[A-Z0-9]+$/,
                      "Product VIN can only contain letters A-Z and numbers 0-9",
                  )
                  .required("Product VIN is required")
            : schema.notRequired(),
    ),
    productChassisID: yup
        .string()
        .when(["productType"], ([productType], schema) =>
            productType === "ChassisID"
                ? schema
                      .trim()
                      .transform((v) =>
                          typeof v === "string" ? v.toUpperCase() : v,
                      )
                      .max(
                          11,
                          "Product Chassis ID must be at most 11 characters long",
                      )
                      .matches(
                          /^[A-Z0-9]+$/,
                          "Product Chassis ID can only contain letters A-Z and numbers 0-9",
                      )
                      .required("Product Chassis ID is required")
                : schema.notRequired(),
        ),
});
